import React, {Component} from 'react';
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,imagesFormatter,
    historyDataFormatter,
    dateFormatter,
    customFormatter,
    getFieldByPathFormatter
} from 'util/Utils';

  import config from  '../../../config';
import {Link} from "react-router";
import {Button, Col} from "react-bootstrap";


class AdminShippingTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentTab: {},
            adminFulfillments: [

            ],
        };
    }






    customActionsFormatter(cell, row, extra) {

        if (_.size(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', []))) {
            var ConnectedTransactionsData = _.reduce(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', []), function (transactionsData, item) {
                _.forEach(_.get(item, 'Transactions', []), transactionData => {
                    transactionsData.push(transactionData)
                })
                return transactionsData
            }, [])
            var transactionsToCheck = _.map(ConnectedTransactionsData, item => {
                return {MarketName:_.get(item,'MarketName'), ClaimedByUserID: _.get(item, 'SaleData.ClaimedByUserID'), ClaimedByUserAt: _.get(item, 'SaleData.ClaimedByUserAt'), ProductState: _.get(item, 'SaleData.ProductState','')}
            })
        } else {
            var transactionsToCheck = _.get(row, 'allOrderTransactions', [])
        }

        transactionsToCheck = _.filter(transactionsToCheck,item=>{
            var MarketsToCheck = [_.get(this.props, 'searchBoxReference.state.filterOptions.Market', 'n/a')]
             var SubMarkets =_.get(config.warehouseData[ _.get(this.props, 'searchBoxReference.state.filterOptions.Market', 'n/a')],'SubMarkets', [])
            if (SubMarkets.length){
                MarketsToCheck =   _.concat(MarketsToCheck,SubMarkets)
            }
            return _.includes(MarketsToCheck,item.MarketName)
        })
//console.log('transactionsToCheck', transactionsToCheck  );

            var allTransactionsPlucked = transactionsToCheck.length > 0 ? _.every(transactionsToCheck, item => {
                return item.ProductState == 'Plucked' || item.ProductState == 'Packed'
            }) : false;
            var allTransactionsPacked = transactionsToCheck.length > 0 ? _.every(transactionsToCheck, item => {
                return item.ProductState == 'Packed'
            }) : false;
            var claimedTransactionExists = transactionsToCheck.length > 0 ? _.some(transactionsToCheck, item => {
                return _.get(item,'ClaimedByUserID') &&  moment().diff(moment(_.get(item, 'ClaimedByUserAt')),'minutes') <120
            }) : false;

            var status =  'Un-Plucked'
            if (allTransactionsPlucked) {
                status =  'Plucked'
            }
            if (allTransactionsPacked){
                status =  'Packed'
            }
        // if (config.getEnvironmentName() !== 'local'){
        //     status =  ''
        // }

             return   <div>
                    <div>
                        <Button bsStyle="link">
                            <Link className="underlineText"
                                  onClick={() => this.props.prepareMultipleOrdersScreen(row, 'EditShippingScreen')}>Edit</Link>
                        </Button>
                        {_.get(row, 'FedexShippingData.FedExShipmentPackagesData') && status == 'Packed' &&
                        <Button className="btn btn-primary pleft3 pright3" style={{width: 100, whiteSpace: 'normal'}}
                                onClick={() => {
                                    this.props.prepareMultipleOrdersScreen(row, 'PrintFedExLabelScreen',)
                                }
                                }>
                            Open FedEx Label
                        </Button>
                        }
                        {_.get(row, 'FedexShippingData.FedExShipmentPackagesData') && !_.get(row, 'FulfilledAt') && status == 'Packed' &&
                        <Button className="btn btn-primary pleft3 pright3 top10  "
                                style={{width: 100, whiteSpace: 'normal'}}
                              //  disabled={true}
                                onClick={() => {
                                    this.props.prepareMultipleOrdersScreen(row, 'FulfillFedExOrderScreen',)
                                }}>
                            Fulfill
                        </Button>
                        }
                        {_.size(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', [])) > 0 &&
                        <div><Button bsStyle="link">
                            <Link className="underlineText"
                                  onClick={(e) => {
                                      row.connectedOrdersAction = 'uncombine'
                                      this.props.prepareMultipleOrdersScreen(row, 'UpdateConnectedTransactionsScreen')
                                  }}>Un-combine</Link>
                        </Button></div>
                        }
                    </div>
                </div>
        }





    render() {
        // console.log('props', this.props  );
        return (
            <div className=" databases-table">
                <BootstrapTable data={this.props.tableData} ref='table'
                                remote={true}
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } } >
                    <TableHeaderColumn  width="100px" dataField="id" isKey={true}  hidden={true} autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataAlign="center" dataField="SaleData.OrderNumber"
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {

                                           path: 'getObject',
                                           format: (row) => {
                                             // var FedExShippingDataFound = _.find(_.get(row, 'ShopifyCustomerTransactions', []), customerTransaction=>{
                                             //     console.log('customerTransaction', customerTransaction  );
                                             //    return  _.get(customerTransaction,'FedexShippingData.MasterTrackingNumber')
                                             // })

                                           return  <div>

                                           <a target="_blank" className=""
                                           href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]", row.SaleData['OrderID']) }>{_.get(row,'SaleData.OrderNumber', 'n/a')}</a>
                                           {  _.size(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', [])) > 0 ?

                                               <div className="top10">
                                                   { _.map(_.reject(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', []), item => {
                                                       return _.get(item, 'ShopifyOrderNumber') == _.get(row, 'SaleData.OrderNumber')
                                                   }), item => {
                                                       return <a target="_blank" key={_.get(item, 'ShopifyOrderID')}  className="right5"
                                                                 href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]", _.get(item, 'ShopifyOrderID', 'n/a')) }>{_.get(item, 'ShopifyOrderNumber', 'n/a')}</a>
                                                   })
                                                   }
                                               </div>
                                               :
                                               <div>
                                                   {  _.size(_.get(row, 'ShopifyCustomerTransactions', [])) > 0 &&
                                                   <div className="top10">
                                                       <a href="" className="pleft5 pink  "
                                                          onClick={(e) => {
                                                              e.preventDefault()
                                                              row.connectedOrdersAction = 'combine'
                                                              this.props.prepareMultipleOrdersScreen(row, 'UpdateConnectedTransactionsScreen')
                                                          }}
                                                       >{'Combine with ' + _.uniq(_.map(_.get(row, 'ShopifyCustomerTransactions', []), item => {
                                                           return _.get(item, 'OrderNumber')
                                                       })).join(', ') }
                                                       </a>
                                                   </div>
                                                   }
                                               </div>
                                           }
                                           </div>

                                       }
                                       }}
                                       dataSort={true}    >Order №</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataField="SaleData.OrderCreateDate" dataAlign="center"
                                       dataFormat={ dateFormatter }
                                       editable={ false }
                                       formatExtraData={ {'path': 'SaleData.OrderCreateDate', 'format': 'MM/DD'} }
                                       dataSort={true}>Order Date</TableHeaderColumn>
                    <TableHeaderColumn width="100px"
                                       editable={ false }    dataFormat={ dateFormatter }
                                       formatExtraData={ {'path': 'FulfillByDate', 'format': 'MM/DD'} }

                                       dataField='FulfillByDate' dataAlign="center"
                                       dataSort={true}>Fulfill By</TableHeaderColumn>
                    {/*<TableHeaderColumn width="30px" dataAlign="center" dataField="ChangeLog"*/}
                                       {/*dataSort={true}*/}
                                       {/*dataFormat={(cell, row)=> historyDataFormatter.call(this,row,  {field:'ChangeLog'} )}>Log</TableHeaderColumn>*/}
                    {/*<TableHeaderColumn width="60px" dataAlign="center"*/}
                                       {/*dataFormat={ customFormatter }*/}
                                       {/*formatExtraData={ {*/}
                                           {/*path: ['getObject'],*/}
                                           {/*format: (record) => {*/}
                                               {/*var deliveryMethod = ''*/}
                                               {/*if (_.get(record, 'WorkWaveEventID')) {*/}
                                                       {/*deliveryMethod = 'GBG'*/}
                                                   {/*} else  if (_.get(record, 'VehoOrderID')) { {*/}
                                                       {/*deliveryMethod = 'Veho'*/}
                                                   {/*}*/}
                                               {/*}*/}
                                               {/*return  deliveryMethod*/}
                                           {/*}}*/}
                                       {/*}*/}
                                       {/*dataField='DeliveryMethod'>Delivery Method</TableHeaderColumn>*/}
                    <TableHeaderColumn width="100px"
                                       editable={ false } dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (record) => {

                                             
                                               return <div>
                                                    {_.get(record, 'ShopifyOrderShippingAddress.province_code') &&
                                                   <div>
                                                       <div>{_.get(record.ShopifyOrderShippingAddress, 'address1', 'n/a') + ' ' + _.get(record.ShopifyOrderShippingAddress, 'address2', 'n/a') + ' ' + _.get(record.ShopifyOrderShippingAddress, 'city', '') + ', ' + _.get(record.ShopifyOrderShippingAddress, 'province_code', '') + ' ' + _.get(record.ShopifyOrderShippingAddress, 'zip', '')}</div>
                                                       {_.get(record.ShopifyOrderShippingAddress, 'phone') &&
                                                       <div
                                                           className="top10">{_.get(record.ShopifyOrderShippingAddress, 'phone')}</div>
                                                       }
                                                   </div>
                                               }

                                                           { _.map(_.get(record, 'FedexShippingData.FedExShipmentPackagesData', []), (item, index) => {

                                                                //  if (config.getEnvironmentName() !== 'local'){
                                                               //    return null
                                                               // }
                                                               return <div key={index}>

                                                                   <div  className="top10 bot10">
                                                                       <div>
                                                                               <a target="_blank" className=" "
                                                                                  href={ _.get(item, 'LabelPDFLink')    }>{'Package   ' + _.get(item,'PackageLength','n/a') +' x '+_.get(item,'PackageWidth','n/a') +' x '+ _.get(item,'PackageHeight','n/a') } </a>
                                                                       </div>
                                                                     </div>

                                                               </div>
                                                           })}

                                               </div>
                                           }}


                                       }

                                       dataField='ShopifyOrderShippingAddress.province_code' dataAlign="center"
                                       dataSort={true}>Contacts</TableHeaderColumn>
                    <TableHeaderColumn width="60px" dataAlign="center"
                                       columnClassName={  'table-cell-with-image' }
                                       dataFormat={(cell, row, columnIndex, rowIndex) => {
                                           return imagesFormatter.call(this,  row,  rowIndex,{
                                               displayMultipleImages:true,
                                               imagePath:   ['allOrderProductsImages'],
                                               imageTitlePath:['ProductName'],
                                               //    total:this.props.total,
                                               perPage:this.state.perPage,
                                               //    currentPage:this.props.currentPage,
                                           } )
                                       }}
                                       dataField=''>Images</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataAlign="center" dataField='Status'
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (record) => {
                                               if (_.size(_.get(record, 'ConnectedTransactionsData.ConnectedTransactions', []))) {
                                                   var ConnectedTransactionsData = _.reduce(_.get(record, 'ConnectedTransactionsData.ConnectedTransactions', []), function (transactionsData, item) {
                                                       _.forEach(_.get(item, 'Transactions', []), transactionData => {
                                                           transactionsData.push(transactionData)
                                                       })
                                                       return transactionsData
                                                   }, [])
                                                   var transactionsToCheck = _.map(ConnectedTransactionsData, item => {
                                                       return {MarketName:_.get(item,'MarketName'), ClaimedByUserID: _.get(item, 'SaleData.ClaimedByUserID'), ClaimedByUserAt: _.get(item, 'SaleData.ClaimedByUserAt'), ProductState: _.get(item, 'SaleData.ProductState','')}
                                                   })
                                               } else {
                                                   var transactionsToCheck = _.get(record, 'allOrderTransactions', [])
                                               }

                                               transactionsToCheck = _.filter(transactionsToCheck,item=>{
                                                   var MarketsToCheck = [_.get(this.props, 'searchBoxReference.state.filterOptions.Market', 'n/a')]
                                                   var SubMarkets =_.get(config.warehouseData[ _.get(this.props, 'searchBoxReference.state.filterOptions.Market', 'n/a')],'SubMarkets', [])
                                                   if (SubMarkets.length){
                                                       MarketsToCheck =   _.concat(MarketsToCheck,SubMarkets)
                                                   }

                                                   return _.includes(MarketsToCheck,item.MarketName)
                                               })


                                               var allTransactionsPlucked = transactionsToCheck.length > 0 ? _.every(transactionsToCheck, item => {
                                                   return item.ProductState == 'Plucked' || item.ProductState == 'Packed'
                                               }) : false;
                                               var allTransactionsPacked = transactionsToCheck.length > 0 ? _.every(transactionsToCheck, item => {
                                                   return item.ProductState == 'Packed'
                                               }) : false;
                                               var claimedTransactionExists = transactionsToCheck.length > 0 ? _.some(transactionsToCheck, item => {
                                                   return _.get(item,'ClaimedByUserID') &&  moment().diff(moment(_.get(item, 'ClaimedByUserAt')),'minutes') <120
                                               }) : false;

                                               var status =  'Un-Plucked'
                                               if (allTransactionsPlucked) {
                                                   status =  'Plucked'
                                               }
                                               if (allTransactionsPacked){
                                                   status =  'Packed'
                                               }
                                               return <div>
                                                   <span>{status}</span>
                                                   { claimedTransactionExists  &&
                                                   <div><a href="" className="pleft5  "
                                                           onClick={(e) => {
                                                               e.preventDefault()

                                                               this.props.prepareMultipleOrdersScreen(record, 'RemoveClaimsForTransactions')
                                                           }}
                                                   >Claimed</a></div>
                                                   }
                                               </div>

                                       }}} >Status</TableHeaderColumn>

                    <TableHeaderColumn width="50px" dataAlign="center"
                                       editable={ false }
                                       dataFormat={ this.customActionsFormatter.bind(this) }>Actions</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}

export default AdminShippingTable;
